import axios from "./config";

export default {
    register: function (accountData) {
        return axios.post("/tenants/register", accountData);
    },
    contactSales: function (data) {
        return axios.post("/tenants/contact", data);
    },
    isDomainValid: function () {
        return axios.get("/");
    }
};